// Booking intent storage utilities
// This handles saving and restoring booking selections for non-logged-in users

const BOOKING_INTENT_KEY = 'booking_intent';

export const saveBookingIntent = (intent) => {
  try {
    const intentData = {
      ...intent,
      timestamp: Date.now(),
      expiresAt: Date.now() + (24 * 60 * 60 * 1000) // 24 hours
    };
    localStorage.setItem(BOOKING_INTENT_KEY, JSON.stringify(intentData));
    console.log('Booking intent saved:', intentData);
  } catch (error) {
    console.error('Failed to save booking intent:', error);
  }
};

export const getBookingIntent = () => {
  try {
    const stored = localStorage.getItem(BOOKING_INTENT_KEY);
    if (!stored) return null;
    
    const intent = JSON.parse(stored);
    
    // Check if intent has expired
    if (intent.expiresAt && Date.now() > intent.expiresAt) {
      clearBookingIntent();
      return null;
    }
    
    return intent;
  } catch (error) {
    console.error('Failed to get booking intent:', error);
    return null;
  }
};

export const clearBookingIntent = () => {
  try {
    localStorage.removeItem(BOOKING_INTENT_KEY);
    console.log('Booking intent cleared');
  } catch (error) {
    console.error('Failed to clear booking intent:', error);
  }
};

export const hasBookingIntent = () => {
  return getBookingIntent() !== null;
};

// Helper to create booking intent from current booking page state
// serviceOrServices: single { serviceName, price } or array of same
export const createBookingIntent = (shop, serviceOrServices, date, time, staff) => {
  if (!shop || !date || !time) {
    return null;
  }
  const services = Array.isArray(serviceOrServices) ? serviceOrServices : (serviceOrServices ? [serviceOrServices] : []);
  if (services.length === 0) return null;

  const totalPrice = services.reduce((sum, s) => sum + Number(s.price || 0), 0);
  return {
    shopName: shop.name,
    shopId: shop._id,
    shopLocation: shop.town,
    services,
    serviceName: services.map(s => s.serviceName).join(', '),
    servicePrice: services.length === 1 ? services[0].price : undefined,
    selectedDate: date,
    selectedHour: time,
    staffName: staff?.name || '',
    staffId: staff?._id || '',
    totalPrice,
    shopImage: shop.imageUrl,
    shopPhone: shop.phone,
    shopRating: shop.rating
  };
};
